<script setup>
import { ref, onMounted } from 'vue' // 'ref' harus diimpor untuk digunakan
import siteManager from '../../components/Dashboard/siteManager.vue'
import dcOwner from '../../components/Dashboard/dcOwner.vue'
const role = ref('dcOwner')
onMounted(() => {
  const storedUserData = localStorage.getItem('userData')
  const userData = JSON.parse(storedUserData)
  role.value = userData.user.role
})
</script>

<template>
  <site-manager v-if="role === 'siteManager' || role === 'admin'" />
  <dc-owner v-else-if="role === 'dcOwner'" />
</template>
